import { render, staticRenderFns } from "./LeicesterAddress.vue?vue&type=template&id=6143ba78&"
import script from "./LeicesterAddress.vue?vue&type=script&lang=js&"
export * from "./LeicesterAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports